import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ModalModule } from 'ngx-bootstrap/modal';

import { SanitizeHtmlPipe } from './sanitizeHtml.pipe';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { JwSocialButtonsModule } from 'jw-angular-social-buttons';

import { HeaderComponent } from './modules/header/header.component';
import { FrontendComponent } from './frontend.component';
import { HomeComponent } from './home/home.component';
import { FooterComponent } from './modules/footer/footer.component';
import { SlideComponent } from './modules/slide/slide.component';
import { BoxproductComponent } from './modules/boxproduct/boxproduct.component';
import { ContactComponent } from './contact/contact.component';
import { LibraryComponent } from './library/library.component';
import { PagesComponent } from './pages/pages.component';
import { ContentComponent } from './content/content.component';
import { DetailcontentComponent } from './detailcontent/detailcontent.component';
import { DetailproductComponent } from './detailproduct/detailproduct.component';
import { BoxContentComponent } from './modules/box-content/box-content.component';
import { CartComponent } from './cart/cart.component';
import { LoginComponent } from './login/login.component';
import { SignupComponent } from './signup/signup.component';
import { ProductsComponent } from './products/products.component'
import { CartService } from '../services/apicart/cart.service';
import { FmloginComponent } from './modules/fmlogin/fmlogin.component';
import { FmsingupComponent } from './modules/fmsingup/fmsingup.component';
import { BoxListGalleryComponent } from './modules/box-list-gallery/box-list-gallery.component';
import { SliderImageComponent } from './modules/slider-image/slider-image.component';
import { BoxcontentGridComponent } from './modules/boxcontent-grid/boxcontent-grid.component'
import { Boxcontent2Component } from './modules/boxcontent-2/boxcontent-2.component'
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import {
	SocialLoginModule,
	AuthServiceConfig,
	GoogleLoginProvider,
	FacebookLoginProvider,
} from "angular5-social-login";
import { Boxcontent3Component } from './modules/boxcontent3/boxcontent3.component';
import { AsidebarRightComponent } from './modules/asidebar-right/asidebar-right.component';
import { InfoComponent } from './info/info.component';
import { InfocartComponent } from './infocart/infocart.component';
import { InforuserComponent } from './inforuser/inforuser.component';
import { InfocartdetailComponent } from './infocartdeatil/infocartdeatil.component';
import { ResetpasswordComponent } from './resetpassword/resetpassword.component';


const appRoutes: Routes = [
	{
		path: '', component: FrontendComponent,
		children: [
			{ path: '', redirectTo: 'trang-chu' },
			{ path: 'trang-chu', component: HomeComponent },
			{ path: 'tin-tuc', component: ContentComponent },
			{ path: 'tin-tuc/:parent_link', component: ContentComponent },
			{ path: 'tin-tuc/:parent_link/:link', component: DetailcontentComponent },
			{ path: 'lien-he', component: ContactComponent },
			{ path: 'san-pham', component: ProductsComponent },
			{ path: 'san-pham/:parent_link', component: ProductsComponent },
			{ path: 'gio-hang', component: CartComponent },
			{ path: 'san-pham/:parent_link/:link', component: DetailproductComponent },
			{ path: 'video-hinh-anh', component: LibraryComponent },
			{ path: 'thu-vien-anh-video', component: LibraryComponent },
			{ path: 'dang-nhap', component: LoginComponent },
			{ path: 'dang-ky', component: SignupComponent },
			{ path: 'thong-tin-don-hang', component: InfoComponent },
			{ path: 'thong-tin-cua-toi', component: InfoComponent },
			{ path: 'thong-tin-cua-toi', component: InfoComponent },
			{ path: 'chi-tiet-don-hang/:id', component: InfoComponent },
			{ path: 'customer/reset_password/:token', component: ResetpasswordComponent },
			{ path: ':link', component: PagesComponent },
		]
	}
]

export function getAuthServiceConfigs() {
	let config = new AuthServiceConfig(
		[
			{
				id: FacebookLoginProvider.PROVIDER_ID,
				provider: new FacebookLoginProvider("2052727905041444")
			},
			{
				id: GoogleLoginProvider.PROVIDER_ID,
				provider: new GoogleLoginProvider("280442937818-1noot499u92p1963050f7k9j9vnv6u5j")
			},
		]
	);
	return config;
}
@NgModule({

	imports: [
		CommonModule,
		TranslateModule,
		FormsModule,
		ModalModule.forRoot(),
		ReactiveFormsModule,
		RouterModule.forChild(appRoutes),
		TypeaheadModule.forRoot(),
		JwSocialButtonsModule,
		SocialLoginModule,
		BsDatepickerModule.forRoot()
	],
	declarations: [
		HeaderComponent,
		FrontendComponent,
		HomeComponent,
		FooterComponent,
		SanitizeHtmlPipe,
		SlideComponent,
		BoxproductComponent,
		ContactComponent,
		LibraryComponent,
		PagesComponent,
		ContentComponent,
		DetailcontentComponent,
		DetailproductComponent,
		BoxContentComponent,
		CartComponent,
		LoginComponent,
		SignupComponent,
		ProductsComponent,
		FmloginComponent,
		FmsingupComponent,
		BoxListGalleryComponent,
		SliderImageComponent,
		BoxcontentGridComponent,
		Boxcontent2Component,
		Boxcontent3Component,
		AsidebarRightComponent,
		InfoComponent,
		InfocartComponent,
		InforuserComponent,
		InfocartdetailComponent,
		ResetpasswordComponent

	],
	providers: [CartService, {
		provide: AuthServiceConfig,
		useFactory: getAuthServiceConfigs
	}],
})
export class FrontendModule { }



// WEBPACK FOOTER //
// ./src/app/frontend/frontend.module.ts